module.exports = __webpack_public_path__ + "img/new-people-customer-employee-branding.67ce6c54.png";